import { REQUEST_METHODS } from '@/constants/network'
import baseFetch from '@/network/baseFetch'
import type { TravellerDetailsResponse } from '@/types/amendTraveller'

export const AMEND_TRAVELLER_DETAILS_PATH = '/amend/travellerDetails'

export type TravellerDetailsQueryParams = {
  source: string
  platform: 'desktop'
}

export function buildTravellerDetailsUrl(
  tripId: string,
  params: TravellerDetailsQueryParams
): string {
  const queryParams = new URLSearchParams({
    source: params.source,
    platform: params.platform,
  })
  return `${AMEND_TRAVELLER_DETAILS_PATH}/${encodeURIComponent(tripId)}?${queryParams.toString()}`
}

export async function fetchTravellerDetailsRequest(
  tripId: string,
  params: TravellerDetailsQueryParams
): Promise<TravellerDetailsResponse> {
  const url = buildTravellerDetailsUrl(tripId, params)
  return baseFetch<TravellerDetailsResponse>({
    url,
    method: REQUEST_METHODS.GET,
  })
}
